export default __webpack_public_path__ + "locales/pl/ChangeEmailDialog.json?hash=18d65762d5984a9ff3edfeba2f7977ac";